import React, { useState } from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { ambientBackgroundSx, pageEnterSx } from '../theme/surfaceStyles';

const Layout = ({ children }) => {
    const [mobileNavOpen, setMobileNavOpen] = useState(false);

    return (
        <Box
            display="flex"
            sx={{
                flex: 1,
                minHeight: 0,
                overflow: 'hidden',
                backgroundColor: 'background.default',
                position: 'relative',
            }}
        >
            <Box sx={(theme) => ambientBackgroundSx(theme)} aria-hidden />
            <Sidebar mobileOpen={mobileNavOpen} onMobileClose={() => setMobileNavOpen(false)} />
            <Box
                flex={1}
                display="flex"
                flexDirection="column"
                minWidth={0}
                minHeight={0}
                sx={{ overflow: 'hidden', position: 'relative', zIndex: 1 }}
            >
                <Header onMenuClick={() => setMobileNavOpen(true)} />
                <Box
                    component="main"
                    flex={1}
                    minHeight={0}
                    overflow="auto"
                    p={{ xs: 1.5, sm: 2, md: 2 }}
                    sx={{
                        maxWidth: 1360,
                        width: "100%",
                        ml: 0,
                        mr: "auto",
                        WebkitOverflowScrolling: "touch",
                        ...pageEnterSx(),
                    }}
                >
                    {children || <Outlet />}
                </Box>
            </Box>
        </Box>
    );
};

export default Layout;
